export default __webpack_public_path__ + "static/media/info-icon.d8c2b46a.svg";